<div class="confirm-cont d-flex justify-content-center align-items-center gap-30 p-30">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container d-flex flex-column justify-content-center align-items-center gap-20">
    <i-tabler [attr.size]="'80'" name="loader" class="spinner-icon"></i-tabler>
    <div class="loading-meta">
      <span class="loading-text">{{ progressLabel }}...</span>
      <span class="loading-subtext" *ngIf="totalTasks > 0">
        {{ processedTasks }} / {{ totalTasks }} tareas completadas ({{ progressPercent }}%)
      </span>
      <div class="progress-track" *ngIf="totalTasks > 0">
        <div class="progress-fill" [style.width.%]="progressPercent"></div>
      </div>
    </div>
  </div>

  <!-- Normal State -->
  <ng-container *ngIf="!loading">
    <div class="icon-circle d-flex justify-content-center align-items-center">
      <i-tabler [attr.size]="'32'" name="alert-circle" class="warning-icon"></i-tabler>
    </div>

    <h2>
      {{ modalTitle }}
    </h2>

    <span *ngIf="warn" class="warn">{{ modalMessage  || "Esta acción no se puede deshacer." }}</span>
    <div class="actions-container d-flex justify-content-center align-items-center">
      <button (click)="onSave()" mat-flat-button color="primary" class="btn-primary">
        {{ mainButtonName }}
      </button>
      <button mat-flat-button (click)="onCancel()" class="btn-cancel">
        Cancelar
      </button>
    </div>
  </ng-container>
</div>
